/** 列表页跳转子页面前暂存检索条件，返回后恢复 */

export const PAGE_STATE_KEYS = {
  INSPECTION_JOB_LIST: "aromaAdmin.inspectionJob.listState",
  CONSIGNMENT_ORDER_LIST: "aromaAdmin.consignmentOrder.listState",
};

export function savePageState(key, state) {
  if (!key || !state) return;
  try {
    sessionStorage.setItem(key, JSON.stringify(state));
  } catch (e) {
    /* ignore quota / private mode */
  }
}

export function consumePageState(key) {
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    sessionStorage.removeItem(key);
    return JSON.parse(raw);
  } catch (e) {
    sessionStorage.removeItem(key);
    return null;
  }
}

export function clearPageState(key) {
  if (!key) return;
  sessionStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/util/listPageState.js